export default __webpack_public_path__ + "static/media/mouse-right-click.2207dcd0.png";